import { getTableColumn, TableColumn } from '@shared/UI';
import { useClientDetailsTable } from './HoldingTableProvider';
import { getHeaderClassName } from '@shared/UI/SimpleTable/lib/getHeaderClassName';
import { HeaderCellWithFilter } from '@shared/UI/SimpleTable/components/HeaderCellWithFilter';
import { BiCaretDown, BiCaretUp } from 'react-icons/bi';

export function getTransactionsTableColumns(): TableColumn<any>[] {
    const { desc, sortFieldName, arrayWithLogos } = useClientDetailsTable();

    const columns: TableColumn<any>[] = [
        getTableColumn({
            title: 'Description',
            flex: 0.25,
            formatter: (_, row) => {
                return (
                    <div className='portfolio__item-security'>
                        {/* <div className='portfolio__item-icon'>
                            {!!arrayWithLogos.find((item: any) => item.symbol === row.symbol)?.link ? (
                                <img
                                    className='positions-table-cell__logos'
                                    src={arrayWithLogos.find((item: any) => item.symbol === row.symbol)?.link}
                                    alt='logo'
                                />
                            ) : (
                                <div className='positions-table-cell__logos placeholder' />
                            )}
                        </div> */}
                        <div className='portfolio__item-details'>
                            <div className='portfolio__item-name'>{row.name}</div>
                        </div>
                    </div>
                );
            },
            headerClassName: `positions-table-header ${getHeaderClassName(sortFieldName, desc, 'symbol')}`,
            headerFormatter: (row) => (
                <HeaderCellWithFilter
                    title={String(row)}
                    icon={undefined}
                    onClick={() => null}
                />
            ),
        }),

        getTableColumn({
            title: 'Symbol',
            flex: 0.2,
            formatter: (_, row) => {
                return (
                    <div className='portfolio__item-security'>
                        {/* <div className='portfolio__item-icon'>
                            {!!arrayWithLogos.find((item: any) => item.symbol === row.symbol)?.link ? (
                                <img
                                    className='positions-table-cell__logos'
                                    src={arrayWithLogos.find((item: any) => item.symbol === row.symbol)?.link}
                                    alt='logo'
                                />
                            ) : (
                                <div className='positions-table-cell__logos placeholder' />
                            )}
                        </div> */}
                        <div className='portfolio__item-details'>
                            <div className='portfolio__item-symbol'>{row.symbol}</div>
                        </div>
                    </div>
                );
            },
            headerClassName: `positions-table-header ${getHeaderClassName(sortFieldName, desc, 'symbol')}`,
            headerFormatter: (row) => (
                <HeaderCellWithFilter
                    title={String(row)}
                    icon={undefined}
                    onClick={() => null}
                />
            ),
        }),

        getTableColumn({
            dataField: 'quantity',
            title: 'Quantity',
            flex: 0.15,
            firstColumn: true,
            headerFormatter: (row) => (
                <HeaderCellWithFilter
                    title='Quantity'
                    icon={undefined}
                    onClick={() => null}
                />
            ),
            headerClassName: `transactions-table-header ${getHeaderClassName(sortFieldName, desc, 'quantity')}`,
        }),

        getTableColumn({
            dataField: 'marketPrice',
            title: 'Market Value',
            flex: 0.15,
            firstColumn: true,
            formatter: (_, row) => {
                return `${row.marketPrice}`; // Format percentage with two decimals and add '%' symbol
            },
            headerFormatter: (row) => (
                <HeaderCellWithFilter
                    title='Market Value '
                    icon={undefined}
                    onClick={() => null}
                />
            ),
            headerClassName: `transactions-table-header ${getHeaderClassName(sortFieldName, desc, 'averagePrice')}`,
        }),

        getTableColumn({
            dataField: 'investmentReturn',
            title: 'Unrealized Gain/Loss',
            flex: 0.15,
            firstColumn: true,
            formatter: (_, row) => {
                const caretColor = row.isPositive ? '#5ECF82' : '#EB3F3C';
                const textColor = caretColor;

                return (
                    <>
                        {row.isPositive && row.quantity > 0 ? (
                            <BiCaretUp style={{ color: caretColor }} />
                        ) : (
                            <BiCaretDown style={{ color: '#EB3F3C' }} />
                        )}
                        <span style={{ color: row.quantity < 0 ? '#EB3F3C' : textColor }}>
                            {row.quantity < 0 ? '$0' : row.investmentReturn}
                        </span>
                    </>
                );
            },
            headerFormatter: (row) => (
                <HeaderCellWithFilter
                    title='Unrealized Gain/Loss'
                    icon={undefined}
                    onClick={() => null}
                />
            ),
            headerClassName: `transactions-table-header ${getHeaderClassName(sortFieldName, desc, 'averagePrice')}`,
        }),
    ];

    return columns;
}
